import {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";

export class EventChartHalfCourtRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number, id) {
    super({width, height});

    this.resourceName = `WebSite/court/half/${id}`;
    this.c = null
  }
}